// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".results{display:flex;justify-content:center;text-align:center;color:#104182;height:3rem;margin:0 0 -5px 0}.results .icon{flex:1 0 auto;margin:0 3% 2px;align-self:center;width:18px;height:18px}.results .nb{flex:1 0 auto;font-size:1em;align-self:center}@media (max-width: 1000px){.results .icon{margin:0 1%;font-size:1em}.results .nb{font-size:0.8em}}\n", ""]);
// Exports
module.exports = exports;
